<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR EIXO TEMÁTICO' : 'NOVO EIXO TEMÁTICO'" titleIcon="fas fa-edit">

            <div v-if="modoEdicao && !carregado" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>

            <el-form v-else label-position="top" :model="dados" ref="dados" @submit.native.prevent="salvar">

                <el-alert type="info" :closable="false" class="u-mb-15"
                    title="Eixos temáticos são a alternativa às disciplinas na organização das matrizes curriculares — usados, por exemplo, na Educação Infantil."></el-alert>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]">
                            <el-input v-model="dados.nome" maxlength="191" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4">
                        <el-form-item label="Sigla">
                            <el-input v-model="dados.sigla" maxlength="20"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="4">
                        <el-form-item label="Ordem">
                            <el-input-number v-model="dados.ordem" :min="0" :step="1" style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="4">
                        <el-form-item label="Situação">
                            <el-select v-model="dados.situacao" style="width: 100%;">
                                <el-option :value="true" label="ATIVO"></el-option>
                                <el-option :value="false" label="INATIVO"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Descrição">
                            <el-input type="textarea" :rows="3" v-model="dados.descricao" placeholder="Descrição do eixo temático"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row class="u-mt-15">
                    <el-col :xs="24" class="u-text-right">
                        <router-link to="/admin/eixo-tematico">
                            <el-button>VOLTAR</el-button>
                        </router-link>
                        <el-button class="u-ml-10" type="primary" native-type="submit">SALVAR</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        dados: { nome: '', sigla: '', descricao: '', ordem: 0, situacao: true },
        modoEdicao: false,
        carregado: false
    }),
    mounted () {
        if (this.$route.params.id) {
            this.modoEdicao = true
            this.carregar(this.$route.params.id)
        }
    },
    methods: {
        carregar (id) {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/eixo-tematico/getById/${id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const reg = r.data || {}
                this.dados.nome = reg.nome || ''
                this.dados.sigla = reg.sigla || ''
                this.dados.descricao = reg.descricao || ''
                this.dados.ordem = reg.ordem || 0
                this.dados.situacao = reg.situacao === false ? false : true
                this.carregado = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) {
                    window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' })
                    return
                }
                window.eventBus.$emit('loading', true)
                const url = this.modoEdicao
                    ? `${this.$store.state.config.baseUrlApi}/api/eixo-tematico/update/${this.$route.params.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/eixo-tematico/store`
                this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Salvo com sucesso.', type: 'success' })
                    this.$router.push('/admin/eixo-tematico')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        }
    }
}
</script>
